import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'

import { IPartnersCoverageGroup } from '../../../../model'
import { COVERAGE_TRANSLATION_KEYS } from '../../../translations'
import { MarketSelector } from '../marketSelector/MarketSelector'

import { CoverageCard } from './CoverageCard'
import { ExportPartnersCoverage } from './ExportPartnersCoverage'

import styles from './CoverageReportHeader.module.scss'

interface ICoverageReportHeaderProps {
  fYear?: number
  markets: IPartnersCoverageGroup[]
  selectedMarketIndex: number
  setSelectedMarketIndex: (index: number) => void
  isLoading: boolean
}

export const CoverageReportHeader = ({
  fYear,
  markets,
  selectedMarketIndex,
  setSelectedMarketIndex,
  isLoading,
}: ICoverageReportHeaderProps) => {
  return (
    <CoverageCard className={styles.cardRoot} variant="header">
      <Flex
        className={styles.root}
        gap="md"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <h2 className={styles.title}>
          <Translation
            text={COVERAGE_TRANSLATION_KEYS.title}
            replaceParams={[{ key: '{fYear}', value: String(fYear).slice(-2) }]}
          />
        </h2>

        <MarketSelector
          markets={markets}
          selectedIndex={selectedMarketIndex}
          setSelectedIndex={setSelectedMarketIndex}
          isLoading={isLoading}
        />

        <ExportPartnersCoverage fYear={fYear} />
      </Flex>
    </CoverageCard>
  )
}
